import { defineAction } from '~/prix'
import anonymizeLocalDatabasesAction from './systemAnonymizeLocalDatabases.action.json' with { type: 'json' }
import { z } from 'zod'

const tableSummarySchema = z.object({
  scope: z.string(),
  table: z.string(),
  columns: z.array(z.string()),
})

const olapTableSummarySchema = tableSummarySchema.extend({
  strategy: z.enum(['mutation', 'rewrite']),
})

const hardeningTableSummarySchema = z.object({
  scope: z.string(),
  table: z.string(),
  rowCount: z.number(),
})

const anonymizeLocalDatabasesDefinition = defineAction({
  ...anonymizeLocalDatabasesAction,

  input: z.object({
    confirmation: z.string(),
  }),
  output: z.object({
    confirmationToken: z.string(),
    salt: z.number(),
    warnings: z.array(z.string()),
    oltp: z.object({
      tableCount: z.number(),
      updatedTables: z.array(tableSummarySchema),
    }),
    olap: z.object({
      tableCount: z.number(),
      updatedTables: z.array(olapTableSummarySchema),
    }),
    hardening: z.object({
      profileShuffle: z.object({
        updatedTables: z.array(hardeningTableSummarySchema),
      }),
      addressShuffle: z.object({
        updatedTables: z.array(hardeningTableSummarySchema),
      }),
      geocoding: z.object({
        clearedTables: z.array(hardeningTableSummarySchema),
        regeneratedTables: z.array(hardeningTableSummarySchema),
      }),
      validations: z.object({
        clickhouseMutations: z.object({
          total: z.number(),
          pending: z.number(),
          failed: z.number(),
        }),
        citizenJoins: z.object({
          checkedRows: z.number(),
          unmatchedRows: z.number(),
        }),
        professionalJoins: z.object({
          checkedRows: z.number(),
          unmatchedRows: z.number(),
        }),
        oltpResidenceJoins: z.object({
          checkedRows: z.number(),
          unmatchedRows: z.number(),
        }),
        citizenAddressBirthYearSexUniqueRows: z.object({
          before: z.number(),
          after: z.number(),
        }),
      }),
    }),
  }),
})

export default anonymizeLocalDatabasesDefinition
